// Angular
import { Component } from '@angular/core';
import { Router } from '@angular/router';

// Ionic
import {
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  ModalController,
  IonButton,
  IonButtons,
  IonIcon
} from '@ionic/angular/standalone';

@Component({
  selector: 'amwager3-show-message-to-complete-registration',
  templateUrl: './show-message-to-complete-registration.component.html',
  styleUrls: ['./show-message-to-complete-registration.component.scss'],
  standalone: true,
  imports: [
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonButtons,
    IonButton,
    IonIcon
  ]
})
export class ShowMessageToCompleteRegistrationComponent {

  constructor(private modalCtrl: ModalController, private router: Router) {}

  goTo(url: string): void {
    this.router.navigate([url]);
    this.dismissModal();
  }

  dismissModal() {
    this.modalCtrl.dismiss();
  }

}
